import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .decline-reason-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .connection-selector-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .decline-reason-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .decline-reason-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
